module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelManagerPage', {
    attrs: {
      "lower-app-name": "emarket",
      "lower-model-name": "categoryl1",
      "version": "1",
      "obj-label": "商品一级分类"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32516aa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CategoryL1Manager.vue
// module id = 371
// module chunks = 1